import React from 'react';
import { Placeholder } from '@components/common/Placeholder';

export const ForgotPassword: React.FC = () => {
  return (
    <Placeholder 
      title="Reset Password" 
      description="Reset your account password."
    />
  );
};